export const NAV_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/about-us' },
  { label: 'Products', href: '/products' },
  { label: 'UK Import', href: '/about-us#export-services' },
  { label: 'Certifications', href: '/about-us#certifications' },
  { label: 'Contact', href: '/contact' },
];

export const HERO_STATS = [
  { value: '100+', label: 'Products for Export' },
  { value: '5', label: 'Main Categories' },
  { value: 'UK', label: 'Main Export Country' },
  { value: '6+', label: 'Secondary Markets' },
];

export const MARQUEE_ITEMS = [
  'Main Market: United Kingdom',
  'Secondary: Europe · UAE · USA · Canada · Australia · Singapore',
  'Wholesale Import',
  'UK-Ready Labelling',
  'FSSAI Certified',
  'Private Label',
  'Sea & Air Freight',
  'HMRC Commodity Codes',
];

export const PAGE_BANNER_DEFAULT_IMAGE = '/images/hero-spices.png';

export const PAGE_BANNER_IMAGES = {
  about: '/images/about-company-hero.png',
  contact: '/images/hero-spices.png',
  products: '/images/hero-spices.png',
  category: '/images/hero-spices.png',
};

export const ABOUT_FEATURES = [
  {
    icon: 'leaf',
    title: 'Built for the UK Trade',
    desc: 'Rice, spices, pulses, millets, flours, oils, and authentic Indian staples — curated first for British wholesalers, cash & carry, and Asian supermarkets, with secondary markets worldwide.',
  },
  {
    icon: 'award',
    title: 'Private Label for UK Retail',
    desc: 'Custom branding, re-labelling, and packaging formats suited to UK shelf requirements and your own brand.',
  },
  {
    icon: 'earth',
    title: 'Flexible UK-Friendly Packing',
    desc: 'From 50g retail packs to bulk sacks — vacuum sealed, export graded, and ready for long-haul transit to the UK and other markets.',
  },
];

export const OIL_SHOWCASE = [
  {
    id: 'groundnut',
    name: 'Cold Pressed Groundnut Oil',
    title: 'Groundnut Oil',
    subtitle: 'Wood-pressed kadalai ennai',
    sizes: '500 ml · 1 L',
    image: '/images/oils/groundnut-v3.png',
    href: '/products/category/oil',
    points: [
      'Manufactured at our own Amma Chekku mill',
      'Traditional wooden chekku — no chemicals',
      'Nutty aroma for everyday South Indian cooking',
    ],
    badge: 'Own Mill',
  },
  {
    id: 'sesame',
    name: 'Cold Pressed Gingelly Oil',
    title: 'Gingelly Oil',
    subtitle: 'Traditional nallennai',
    sizes: '500 ml · 1 L',
    image: '/images/oils/sesame-v3.png',
    href: '/products/category/oil',
    points: [
      'Pressed in-house on Amma Chekku wooden mills',
      'Slow cold extraction retains natural nutrients',
      'Ideal for tempering, oil pulling & authentic meals',
    ],
    badge: 'Chekku Pressed',
  },
  {
    id: 'coconut',
    name: 'Cold Pressed Coconut Oil',
    title: 'Coconut Oil',
    subtitle: 'Marachekku virgin coconut oil',
    sizes: '500 ml · 1 L',
    image: '/images/oils/coconut-v3.png',
    href: '/products/category/oil',
    points: [
      'Made from fresh copra at our Amma Chekku mill',
      'Unheated wood-press process — pure & natural',
      'For cooking, hair care and daily wellness',
    ],
    badge: 'Mill Fresh',
  },
];

export const PROCESS_STEPS = [
  {
    num: '01',
    title: 'Sourcing in India',
    desc: 'Direct procurement from trusted farms and mills across Tamil Nadu and South India.',
  },
  {
    num: '02',
    title: 'Export Quality Control',
    desc: 'Every batch inspected, cleaned, and graded to international export standards.',
  },
  {
    num: '03',
    title: 'Export Packing',
    desc: 'Vacuum sealing and repacking from 50g to bulk — tailored to your UK order requirements.',
  },
  {
    num: '04',
    title: 'Export Documentation',
    desc: 'HS commodity codes, certificates of origin, phytosanitary docs, and full export paperwork prepared.',
  },
  {
    num: '05',
    title: 'Freight to the UK',
    desc: 'Sea freight to Felixstowe, Southampton, or London Gateway — air freight available for urgent orders.',
  },
  {
    num: '06',
    title: 'UK Delivery',
    desc: 'Coordinated customs clearance and delivery to your UK warehouse, depot, or distribution centre.',
  },
];

export const FOOTER_QUICK_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/about-us' },
  { label: 'Products', href: '/products' },
  { label: 'UK Import', href: '/about-us#export-services' },
  { label: 'Contact', href: '/contact' },
];

export const FOOTER_EXPORT_LINKS = [
  { label: 'Main Market: United Kingdom', href: '/about-us' },
  { label: 'Secondary Markets', href: '/about-us' },
  { label: 'Certifications', href: '/about-us#certifications' },
  { label: 'Request Export Quote', href: '/contact' },
];

export const IMAGES = {
  hero: '/images/hero-spices.png',
  aboutMain: '/images/about-export-main.png',
  aboutInset: '/images/about-export-inset.png',
};

export const HOME_PRODUCT_FILTERS = [
  'All',
  'Spices',
  'Cereals',
  'Rices',
  'Oil',
  'Sugars',
  'Snacks',
];

export const HOME_PRODUCTS = [
  // Spices
  {
    name: 'Kashmiri Saffron',
    origin: 'Pampore, Kashmir',
    tagline: 'The crimson thread of luxury',
    tasting: 'Floral, honey, hay',
    category: 'Spices',
    filter: 'spices',
    accent: 'saffron',
    image: '/images/product-saffron.png',
  },
  {
    name: 'Lakadong Turmeric',
    origin: 'Meghalaya Hills',
    tagline: '7.2% curcumin gold',
    tasting: 'Earthy, peppery, warm',
    category: 'Spices',
    filter: 'spices',
    accent: 'turmeric',
    image: '/images/product-turmeric.png',
  },
  {
    name: 'Guntur Red Chili',
    origin: 'Andhra Pradesh',
    tagline: 'Sun-fire intensity',
    tasting: 'Smoky, fruity, bold',
    category: 'Spices',
    filter: 'spices',
    accent: 'chili',
    image: '/images/product-chili.png',
  },
  {
    name: 'Malabar Cardamom',
    origin: 'Idukki, Kerala',
    tagline: 'Queen of spices',
    tasting: 'Citrus, mint, eucalyptus',
    category: 'Spices',
    filter: 'spices',
    accent: 'cardamom',
    image: '/images/product-cardamom.png',
  },
  {
    name: 'Tellicherry Pepper',
    origin: 'Wayanad, Kerala',
    tagline: 'King of spices',
    tasting: 'Pungent, woody, citrus',
    category: 'Spices',
    filter: 'spices',
    accent: 'soil',
    image: '/images/product-pepper.png',
  },
  {
    name: 'Jeera Cumin Seeds',
    origin: 'Rajasthan',
    tagline: 'Desert harvested',
    tasting: 'Nutty, warm, earthy',
    category: 'Spices',
    filter: 'spices',
    accent: 'saffron',
    image: '/images/product-cumin.png',
  },
  // Cereals
  {
    name: 'Toor Dal',
    origin: 'Tamil Nadu, India',
    tagline: 'Split pigeon peas — export grade',
    tasting: 'Mild, nutty, earthy',
    category: 'Cereals',
    filter: 'cereals',
    accent: 'turmeric',
    image: '/images/product-cumin.png',
  },
  {
    name: 'Moong Dal',
    origin: 'Tamil Nadu, India',
    tagline: 'Golden split mung beans',
    tasting: 'Soft, mild, creamy',
    category: 'Cereals',
    filter: 'cereals',
    accent: 'cardamom',
    image: '/images/product-blend.png',
  },
  {
    name: 'Masoor Dal',
    origin: 'Tamil Nadu, India',
    tagline: 'Red lentils — quick cooking',
    tasting: 'Earthy, peppery, warm',
    category: 'Cereals',
    filter: 'cereals',
    accent: 'chili',
    image: '/images/product-pepper.png',
  },
  {
    name: 'Broken Wheat',
    origin: 'Tamil Nadu, India',
    tagline: 'Samba rava for upma & porridge',
    tasting: 'Nutty, wholesome, mild',
    category: 'Cereals',
    filter: 'cereals',
    accent: 'saffron',
    image: '/images/product-blend.png',
  },
  {
    name: 'White Semolina',
    origin: 'Tamil Nadu, India',
    tagline: 'Fine rava for idli & kesari',
    tasting: 'Light, neutral, smooth',
    category: 'Cereals',
    filter: 'cereals',
    accent: 'turmeric',
    image: '/images/product-turmeric.png',
  },
  {
    name: 'Rice Semolina',
    origin: 'Tamil Nadu, India',
    tagline: 'Saapadu rava export quality',
    tasting: 'Delicate, starchy, clean',
    category: 'Cereals',
    filter: 'cereals',
    accent: 'soil',
    image: '/images/product-blend.png',
  },
  // Rices
  {
    name: 'Ponni Rice',
    origin: 'Tamil Nadu, India',
    tagline: 'Premium parboiled export grade',
    tasting: 'Soft, fluffy, aromatic',
    category: 'Rices',
    filter: 'rices',
    accent: 'turmeric',
    image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=800&q=80',
  },
  {
    name: 'Sona Masoori Rice',
    origin: 'South India',
    tagline: 'Lightweight everyday rice',
    tasting: 'Delicate, non-sticky, mild',
    category: 'Rices',
    filter: 'rices',
    accent: 'saffron',
    image: '/images/product-blend.png',
  },
  {
    name: 'Seeraga Samba Rice',
    origin: 'Tamil Nadu, India',
    tagline: 'Aromatic jeerakasala rice',
    tasting: 'Fragrant, firm, biryani-ready',
    category: 'Rices',
    filter: 'rices',
    accent: 'cardamom',
    image: '/images/product-blend.png',
  },
  {
    name: 'Jeera Rice',
    origin: 'Tamil Nadu, India',
    tagline: 'Cumin-scented samba rice',
    tasting: 'Warm spice, long grain',
    category: 'Rices',
    filter: 'rices',
    accent: 'chili',
    image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=800&q=80',
  },
  {
    name: 'Matta Rice',
    origin: 'Kerala, India',
    tagline: 'Red parboiled Kerala rice',
    tasting: 'Robust, nutty, hearty',
    category: 'Rices',
    filter: 'rices',
    accent: 'soil',
    image: '/images/product-blend.png',
  },
  {
    name: 'Idly Rice',
    origin: 'Tamil Nadu, India',
    tagline: 'Short-grain idli specialist',
    tasting: 'Soft, fermented, fluffy',
    category: 'Rices',
    filter: 'rices',
    accent: 'turmeric',
    image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=800&q=80',
  },
  // Oil — manufactured at our own Amma Chekku mill
  {
    name: 'Cold Pressed Coconut Oil',
    origin: 'Tamil Nadu, India',
    tagline: 'From our Amma Chekku mill',
    tasting: 'Rich, tropical, pure',
    category: 'Oil',
    filter: 'oil',
    accent: 'cardamom',
    image: '/images/oils/coconut-v3.png',
  },
  {
    name: 'Cold Pressed Groundnut Oil',
    origin: 'Tamil Nadu, India',
    tagline: 'Wood-pressed at our own mill',
    tasting: 'Nutty, golden, aromatic',
    category: 'Oil',
    filter: 'oil',
    accent: 'saffron',
    image: '/images/oils/groundnut-v3.png',
  },
  {
    name: 'Cold Pressed Gingelly Oil',
    origin: 'Tamil Nadu, India',
    tagline: 'Amma Chekku nallennai',
    tasting: 'Toasty, deep, sesame-rich',
    category: 'Oil',
    filter: 'oil',
    accent: 'turmeric',
    image: '/images/oils/sesame-v3.png',
  },
  {
    name: 'Castor Oil',
    origin: 'Tamil Nadu, India',
    tagline: 'Pressed at our Amma Chekku mill',
    tasting: 'Thick, clean, medicinal',
    category: 'Oil',
    filter: 'oil',
    accent: 'soil',
    image: '/images/oils/castor.png',
  },
  {
    name: 'Virgin Coconut Oil',
    origin: 'Tamil Nadu, India',
    tagline: 'Unrefined from our mill',
    tasting: 'Fresh coconut, light, clean',
    category: 'Oil',
    filter: 'oil',
    accent: 'chili',
    image: '/images/oils/coconut-v3.png',
  },
  {
    name: 'Filtered Groundnut Oil',
    origin: 'Tamil Nadu, India',
    tagline: 'From our Amma Chekku range',
    tasting: 'Neutral, light, versatile',
    category: 'Oil',
    filter: 'oil',
    accent: 'cardamom',
    image: '/images/oils/groundnut-v3.png',
  },
  // Sugars
  {
    name: 'Cane Jaggery Powder',
    origin: 'Tamil Nadu, India',
    tagline: 'Natural unrefined sweetener',
    tasting: 'Molasses, caramel, warm',
    category: 'Sugars',
    filter: 'sugars',
    accent: 'saffron',
    image: 'https://images.unsplash.com/photo-1606312619070-d48b4cbc1225?w=800&q=80',
  },
  {
    name: 'Round Jaggery',
    origin: 'Tamil Nadu, India',
    tagline: 'Traditional gundu vellam',
    tasting: 'Rich, earthy, deep sweet',
    category: 'Sugars',
    filter: 'sugars',
    accent: 'chili',
    image: 'https://images.unsplash.com/photo-1606312619070-d48b4cbc1225?w=800&q=80',
  },
  {
    name: 'Cube Jaggery',
    origin: 'Tamil Nadu, India',
    tagline: 'Achu vellam export blocks',
    tasting: 'Solid, mellow, rustic',
    category: 'Sugars',
    filter: 'sugars',
    accent: 'turmeric',
    image: 'https://images.unsplash.com/photo-1606312619070-d48b4cbc1225?w=800&q=80',
  },
  {
    name: 'Palm Jaggery',
    origin: 'Tamil Nadu, India',
    tagline: 'Panang karuppatti blocks',
    tasting: 'Smoky palm, mineral sweet',
    category: 'Sugars',
    filter: 'sugars',
    accent: 'cardamom',
    image: 'https://images.unsplash.com/photo-1606312619070-d48b4cbc1225?w=800&q=80',
  },
  {
    name: 'Palm Sugar Cubes',
    origin: 'Tamil Nadu, India',
    tagline: 'Panang kalkandu crystals',
    tasting: 'Light, floral, delicate',
    category: 'Sugars',
    filter: 'sugars',
    accent: 'soil',
    image: 'https://images.unsplash.com/photo-1606312619070-d48b4cbc1225?w=800&q=80',
  },
  {
    name: 'Crystal Rock Candy',
    origin: 'Tamil Nadu, India',
    tagline: 'Katti kalkandu export grade',
    tasting: 'Pure, crystalline, clean',
    category: 'Sugars',
    filter: 'sugars',
    accent: 'saffron',
    image: 'https://images.unsplash.com/photo-1606312619070-d48b4cbc1225?w=800&q=80',
  },
  // Snacks
  {
    name: 'Banana Chips',
    origin: 'Tamil Nadu, India',
    tagline: 'Nendran chips — crispy gold',
    tasting: 'Salty, sweet, crunchy',
    category: 'Snacks',
    filter: 'snacks',
    accent: 'turmeric',
    image: '/images/product-saffron.png',
  },
  {
    name: 'Achu Murukku',
    origin: 'Tamil Nadu, India',
    tagline: 'Traditional moulded murukku',
    tasting: 'Crisp, spiced, savory',
    category: 'Snacks',
    filter: 'snacks',
    accent: 'chili',
    image: '/images/product-chili.png',
  },
  {
    name: 'Madras Mixture',
    origin: 'Tamil Nadu, India',
    tagline: 'Classic South Indian mixture',
    tasting: 'Spicy, crunchy, tangy',
    category: 'Snacks',
    filter: 'snacks',
    accent: 'saffron',
    image: '/images/product-blend.png',
  },
  {
    name: 'Thattai',
    origin: 'Tamil Nadu, India',
    tagline: 'Crispy rice flour crackers',
    tasting: 'Light, peppery, crisp',
    category: 'Snacks',
    filter: 'snacks',
    accent: 'cardamom',
    image: '/images/product-pepper.png',
  },
  {
    name: 'Masala Peanuts',
    origin: 'Tamil Nadu, India',
    tagline: 'Spiced verkadalai export pack',
    tasting: 'Hot, nutty, bold',
    category: 'Snacks',
    filter: 'snacks',
    accent: 'soil',
    image: '/images/product-cumin.png',
  },
  {
    name: 'Kai Murukku',
    origin: 'Tamil Nadu, India',
    tagline: 'Hand-pressed murukku rings',
    tasting: 'Buttery, crisp, aromatic',
    category: 'Snacks',
    filter: 'snacks',
    accent: 'turmeric',
    image: '/images/product-turmeric.png',
  },
];

const HOME_FILTER_MAP = {
  Spices: 'spices',
  Cereals: 'cereals',
  Rices: 'rices',
  Oil: 'oil',
  Sugars: 'sugars',
  Snacks: 'snacks',
};

export function getHomeProducts(filter) {
  const items =
    filter === 'All'
      ? HOME_PRODUCTS.filter((p) => p.filter === 'spices')
      : HOME_PRODUCTS.filter((p) => p.filter === HOME_FILTER_MAP[filter]);

  return items.slice(0, 6);
}
